import { Component, inject, DestroyRef, Input } from '@angular/core';
import * as _ from 'lodash';
import { HelpersService } from '../../services/helpers/helpers.service';
import { VerbatimService } from '../../services/verbatim/verbatim.service';
import { UtilsService } from '../../services/utils/utils.service';
import { MSG_CONST } from 'src/app/shared/constants/msg-constants';
import { LtmsEventHandlerService } from '../../services/ltms-event-handler/ltms-event-handler.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalFilterService } from '../../services/filters/global-filter.service';
import { NgIf, NgFor, NgStyle, JsonPipe, KeyValuePipe } from '@angular/common';
import { LtmsErrorComponent } from '../ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../ltms-loader/ltms-loader.component';
import { FeedDetailPanelComponent } from '../feed-detail-panel/feed-detail-panel.component';
import { LitmusResponseDownloaderComponent } from '../litmus-response-downloader/litmus-response-downloader.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    selector: 'app-verbatim-home',
    templateUrl: './verbatim-home.component.html',
    styleUrls: ['./verbatim-home.component.scss'],
    imports: [NgIf, NgFor, NgStyle, LtmsErrorComponent, LtmsLoaderComponent, FeedDetailPanelComponent, LitmusResponseDownloaderComponent, JsonPipe, KeyValuePipe, TranslateModule]
})
export class VerbatimHomeComponent {
  @Input() isAccountLevel: boolean = false;
  destroyRef = inject(DestroyRef);
  desclaimer: string = 'Explore individual customer comments and feedback firsthand. Expand each card for deeper insights or click to dive into more details.';
  feeds: any = [];
  feedChunks: any = [];
  fromDate!: number;
  toDate!: number;
  hierarchyFilters: any = [];
  hierarchyStack: any = [];
  pageLimit = 10;
  pageNumber = 1;
  wordLimit = 80;
  defaultWordLimit = 80;
  brandColor = {}
  usersMap: any = {};
  managersMap: any = {};
  loadMore: boolean = false;
  isADRMOdalOpen: boolean = false;
  filters: any = {}
  brandDetails: any = {};
  dateFilterType: number = 1
  loadMoreResponse = MSG_CONST.LOAD_MORE;
  noMoreResponse = MSG_CONST.NO_MORE_LOAD;
  pagerBusy: boolean = true;
  errorCode: string = '404';
  feedIdList: any = [];
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: this.pageLimit,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  feedDetailsView: any = {
    open: false,
    isNext: false,
  }
  offsetMapping:any={}
  isReportDownloadAllowed: boolean = false;
  constructor(
    private _helpers: HelpersService,
    private _verbatim: VerbatimService,
    public _utilsService: UtilsService,
    private _ltmsEvent: LtmsEventHandlerService,
    private globalFilterService: GlobalFilterService,
  ) { }

  ngOnInit() {
    
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state  && !state.pending) {
        if(Helpers && Helpers['isAccount'] == false && _.get(Helpers, "brandDetails._id")) {
          this.dateFilterType = state.datePicker.dateFilterType;
          this.brandDetails = state.brandDetails
          this.isReportDownloadAllowed = this._helpers.isReportDownloadEnabled();
          this.hierarchyStack = Helpers.getHierarchyStack();
          this.offsetMapping[Helpers.brandDetails._id] = this._helpers.getBrandTimezoneDetails(Helpers.brandDetails)
        }
        this.resetParams()
        this.getFeeds()
      }
    })
  }

  getFeeds() {
    this.pagerBusy = true;
    this.hierarchyFilters = [];
    var params = {};

    params = {
      "account_id": null,
      "brand_id": null,
      "isVerbatim": true,
      "data_source": 2, // 1: Mongo, 2: ES
      "from": _.get(Helpers, "datePicker.startDate"),
      "to": _.get(Helpers, "datePicker.endDate"),
      "custom_filter_list": [],
      "universal_filter": null,
      "limit": this.pageLimit,
      project_type: _.get(Helpers,"projectType.project_type"),
      "page_number": this.pageNumber
    }

    if(Helpers && Helpers['isAccount']) {
      params['account_id'] = _.get(Helpers, "accessObject.account_id");
    }else {
      if (this.hierarchyStack != undefined) {
        this.prepareHierarchyFilter() // Assign hierarchy filter
      }
      params['brand_id'] = _.get(Helpers, "accessObject.brand_id");
      params['custom_filter_list'] = this.hierarchyFilters;
      params['universal_filter'] = _.get(Helpers, "universalFilter");
    }

    this.filters = params
    this.filters['dateFilterType'] = this.dateFilterType;
    this.filters['verbatim_limit'] = this.brandDetails.verbatim_limit ? parseInt(this.brandDetails.verbatim_limit) : null;

    this._verbatim.getFeeds(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (feedsDetail) => {
        if (feedsDetail.data && feedsDetail.data.message === 'Success') {
          // On initial load making array empty, preventing UI card repeatation 
          if (this.pageNumber == 1) {
            this.feeds = [];
            this.feedChunks = [];
          }
          this.updateBrandMapping(feedsDetail.data.brands);
          // Check if have to load more data
          this.isLoadMore(feedsDetail.data.feed)

          // Update feeds with verbatim limit
          this.updateFeeds(feedsDetail.data.feed);
          this.updatePagingDetails(feedsDetail.data.total_feeds, this.pageNumber)
          this.usersMap = this.getMap(feedsDetail.data.users, "_id");
          this.managersMap = this.getMap(feedsDetail.data.managers, "_id");

          if (Helpers && Helpers['isAccount'] == false && Helpers.accessObject && Helpers.accessObject.brand_id) {
            var brands = {}
            brands[Helpers.brandDetails._id] = Helpers.brandDetails;
            this.feeds = this.feeds.concat(this.brandFieldMapper(brands, feedsDetail.data.feed));
          } else {
            this.feeds = this.feeds.concat(this.brandFieldMapper(feedsDetail.data.brands, feedsDetail.data.feed));
          }
          this.feedChunks = this.chunk(this.feeds, 5)
          this.feedIdList = _.map(this.feeds, (feedsDetail: any) => {
            return feedsDetail._id
          })
          if (this.feedDetailsView.open) { 
            const pagerNumber = this.pageNumber -1
            const index = (this.feedDetailsView.isNext)?(pagerNumber * this.pageLimit): (this.pageNumber * this.pageLimit) - 1;
            this.feedDetailsView.open = false;
            const tempFeed = {
              _id: this.feedIdList[index]
            }
            this.openFeed(tempFeed)
          }
        } else {
          // Handling error 
        }
        this.pagerBusy = false;
      },
      error: (err) => {
        this.pagerBusy = false;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })

  }

  openADRModal() {
    if (!Helpers.isAccountManager) {
      this.isADRMOdalOpen = true;
    } else {
      Helpers.smallAlertBox("Error", "ADR is not supported for Account-level users. Please update your access to Project-level.", "error");
    }
  }
  
  closeADRModal() {
    this.isADRMOdalOpen = false;
  }

  updateBrandMapping(brands: any) {
    if (!_.isEmpty(brands)) {
      _.each(brands, (brand: any) => {
        this.offsetMapping[brand._id] = this._helpers.getBrandTimezoneDetails(brand)
      })
    }
  }

  resetParams() {
    this.pageNumber = 1;
    this.feeds = [];
    this.hierarchyFilters = [];
    this.feedChunks = [];
  }

  isLoadMore(feeds) {
    if (feeds && feeds.length > 9) {
      this.loadMore = true;
    } else {
      this.loadMore = false;
    }
  }

  updateFeeds(feeds) {
    var tempComment = [];
    feeds.forEach(feed => {
      if (this._utilsService.getProp(feed, "feed_params.comments")) {
        tempComment = feed.feed_params.comments.split(' ');
        feed.created_date = this._helpers.getTimeByOffset(this.offsetMapping[feed.brand_id]["__zone_symbol__value"]['offset'], _.get(feed, 'created_date'), "DD MMM 'YY HH:mm:ss");
        feed.feedback_request_date = this._helpers.getTimeByOffset(this.offsetMapping[feed.brand_id]["__zone_symbol__value"]['offset'], _.get(feed, 'feedback_request_date'), "DD MMM 'YY HH:mm:ss");
        feed.feed_params.comments = tempComment.slice(0, this.wordLimit).join(' ') + ((tempComment.length >= this.defaultWordLimit) ? "..." : "")
      }
    });
  }

  brandFieldMapper(brands, feeds) {
    var feedsDetail: any = [];
    for (var key in brands) {
      this.brandColor = {}
      if (this._utilsService.getProp(brands, key + ".rating_levels")) {
        brands[key]['rating_levels'].forEach(level => {
          this.brandColor[level['value']] = level;
        })
      }
      feeds.forEach(feed => {
        if (feed['brand_id'] === key) {
          feed['readMore'] = false;
          feed['wordLimit'] = this._utilsService.getProp(brands[key], "module_configuration_v2.scores.sub_modules.verbatim.wordLimit") || this.defaultWordLimit;
          feed['isTokenisedProject'] = this._utilsService.getProp(brands[key], "security_settings.tokenization_server.secret_key");

          // Get cohort data
          this._utilsService.getProp(brands, key + ".field_definitions").forEach(field => {
            if (!feed['transactionalData']) {
              feed['transactionalData'] = {};
            }

            if (field["show_in_inbox_detail"] || field["show_in_inbox_detail"] == "true") {
              if (field.field_id == "assigned_to_id_list" || field.field_id == "assigned_to_managers") {
                feed['assignee'] = this.getAssigneeNameBasedOnList(feed, brands[key]);
              }
            }

            if ((field["es_filter"] || field["es_filter"] == "true") && (field["possible_value_search"] || field["possible_value_search"] == "true")) {
              if (field.field_id.includes("tag_") && !field.field_id.includes("tag_private_")) {
                feed['transactionalData'][field['name']] = this.getTagDataBasedOnField(feed, field['field_id']);
              }
            }

            if (feed['transactionalData'] && Object.keys(feed['transactionalData']).length === 0) {
              feed['transactionalData'] = null;
            }
          });

          feed['color'] = this.brandColor[feed.feed_params.primary_rating];
          feedsDetail.push(feed);
        }
      });
    }
    return feedsDetail;
  }

  prepareHierarchyFilter() {
    this.hierarchyStack.forEach(hierarchy => {
      this.hierarchyFilters.push({
        "field": hierarchy.field_id,
        "value": hierarchy.group_key[0]
      })
    });
  }

  getMap(data, key) {
    var result = {};
    _.each(data, function (d) {
      result[d[key]] = d;
    })
    return result;
  }
  // chunk: Method to divide array into rows and columns, where each row will contains equal no of elements
  chunk(arr, elemsInEachRow) {
    // For no. of elements in each row. Default will be 4.
    var noOfElems = elemsInEachRow;
    if (arr.length < elemsInEachRow) {
      noOfElems = arr.length;
    }
    // Data to be chucked in following manner: [1,2,3,4,5,6] ==> [[1,5], [2,6], [3], [4]]
    var rows = new Array(noOfElems);
    var elemToInsertAt = 0;

    _.each(arr, function (arrElem, arrIndex) {
      elemToInsertAt = arrIndex % noOfElems;
      // If not defined then set it with empty array
      if (!rows[elemToInsertAt]) {
        rows[elemToInsertAt] = [];
      }
      rows[elemToInsertAt].push(arrElem);
    })
    return rows;
  }
  toggelDetails(flag, column, row): void {
    this.feedChunks[column][row]['readMore'] = flag;
  }
  loadMoreFeeds(el: HTMLElement) {
    this.pageNumber = this.pageNumber + 1;
    this.getFeeds();
    el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  getAssigneeNameBasedOnList(feed, brandDetail) {
    var assigneesName = '';
    if (feed.role_assigned_to) {
      var hierarchyHash = this.prepareHierarchyLevelDetail(this._utilsService.getProp(brandDetail, "hierarchy_list"), this._utilsService.getProp(brandDetail, "hierarchy_list_alias"), true);
      assigneesName = (hierarchyHash[feed.role_assigned_to["level"]] || hierarchyHash[feed.role_assigned_to["value"]] || "") + " (" + feed.role_assigned_to["value"] + ")";
    } else {
      _.each(feed.assigned_to_id_list, (assigneeId, index) => {
        assigneesName += (this.managersMap && this.managersMap[assigneeId] && this.managersMap[assigneeId].name) ? ((index != 0) ? ", " : "") + this.managersMap[assigneeId].name : "";
      })
    }
    return (assigneesName && assigneesName.length) ? assigneesName : "NA";
  }

  prepareHierarchyLevelDetail(dataList, dataListAlias, isHashRequired) {
    if (dataList && dataListAlias) {
      var keys = Object.keys(dataList);
      var lastKey = keys[keys.length - 1];
      var lastVal = dataList[lastKey];

      if (isHashRequired) {
        var detail = {};
        if (lastVal && lastVal.length) {
          _.each(lastVal, function (val, index) {
            // replace spcace with underscore
            val = val.replace(/ /g, "_");
            detail[dataListAlias[lastKey]['values'][index]] = val;
          })
        }
        return detail;
      } else {
        var details: any = [];
        if (lastVal && lastVal.length) {
          _.each(lastVal, function (val, index) {
            // replace spcace with underscore
            val = val.replace(/ /g, "_");
            details.push({
              "id": dataListAlias[lastKey]['values'][index],
              "text": val
            });
          })
        }
        return details;
      }
    }
    return (isHashRequired) ? {} : [];
  }

  getTagDataBasedOnField(feed, fieldId) {
    var fieldValue = this._utilsService.getProp(feed["feedback_request_data"], fieldId);
    if (fieldValue && _.isArray(fieldValue)) {
      fieldValue = fieldValue.toString();
      fieldValue = (fieldValue.length == 0) ? "NA" : fieldValue;
    }
    // Seperate with multi line if found (,)
    if (fieldValue && fieldValue.includes(',')) {
      fieldValue = fieldValue.replace(',', ', ')
    }
    return fieldValue;
  }

  openFeed(feed: any) {
    this._ltmsEvent.emit('feed-detail-panel', {
      feed_id: feed._id,
      isVerbatim:true,
      feedIdList: (this.feedIdList && this.feedIdList.length) ? this.feedIdList : [],
      pagingDetails: this.pagingDetails
    })
  }

  updatePagingDetails(totalfeeds: number, pageNumber: number) {
    if (totalfeeds > this.pagingDetails.pageSize) {
      pageNumber = (pageNumber > 0) ? pageNumber : 0;
      let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 0;
      let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : 0;
      end = (totalfeeds < this.pagingDetails.pageSize) ? totalfeeds : end;
      this.pagingDetails = {
        start: start,
        end: end,
        pageSize: 10,
        pageNumber: pageNumber,
        total: totalfeeds,
        totalpages: pageNumber
      }
    } else {
      this.pagingDetails = {
        start: 0,
        end: 0,
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        totalpages: 1
      }
    }
    this.pagingDetails.total = totalfeeds;
  }
  onPageChange(event: any) {
    const el: any = document.getElementById('verbatimCard_' + this.pageNumber);
    this.feedDetailsView.open = true;
    this.feedDetailsView.isNext = _.get(event, 'isNext', false)
    this.pageNumber = _.get(event, 'pageNumber', 1)
    this.getFeeds();
    el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }
  getEmoticonImageUrl(feed) {
    if(feed && feed.feed_params &&  (feed.feed_params.primary_rating != undefined || feed.feed_params.primary_rating != null) ) {
      return 'url(assets/images/verbatim/emoticon_'+feed.feed_params.primary_rating+'.svg)';
    }else {
      return '';
    }
  }
}
